import React from "react";
import { SlotsList } from "@/components/slots/SlotsList";

const SlotsPage: React.FC = () => {
  return <SlotsList />;
};

export default SlotsPage;
